<template>
  <div id="app" class="full">
    <router-view/>
  </div>
</template>

<script type="text/javascript">
import translations from '@/mixins/pagination/providers/translations'

export default {
  name: 'app',

  data () {
    return {
      // This prop is used by tests!
      testProp: {}
    }
  },

  mixins: [
    translations
  ]
}

if (process.env.NODE_ENV === 'beta') {
  var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
  (function(){
  var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
  s1.async=true;
  s1.src='https://embed.tawk.to/59bf8327c28eca75e4620a65/default';
  s1.charset='UTF-8';
  s1.setAttribute('crossorigin','*');
  s0.parentNode.insertBefore(s1,s0);
  })();
}
</script>

<style scoped>
#app {
  min-height: 100vh;
  font-family: 'Montserrat', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #F8F8F8;
}
.full {
  max-width: 100%!important;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue?3fbe1b90